// frontend/apps/demo/piwa-portfolio/src/routing/public.routes.tsx
import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// Lazy load pages for code splitting
const PortfolioPrehistorikPage = lazy(() =>
  import("../pages/portfolio-prehistorik.page").then((m) => ({
    default: m.PortfolioPrehistorikPage,
  }))
);
const SpriteCalibrationEnhancedPage = lazy(() =>
  import("../pages/sprite-calibration.page").then((m) => ({
    default: m.SpriteCalibrationPage,
  }))
);

export const publicRoutes: RouteObject[] = [
  {
    path: "/",
    element: <PortfolioPrehistorikPage />, // Prehistorik Man themed portfolio
  },
  {
    path: "/calibrate",
    element: <SpriteCalibrationEnhancedPage />, // Enhanced sprite calibration with all features
  },
];
